import {IconName} from '@udemy-v2/icons';
import {CurriculumItemType} from '@udemy-v2/browse-course';

/**
 * Returns an icon for a given curriculum item type
 * @param type - The type of curriculum item
 * @returns An icon element
 */
export function curriculumItemIcon(type: CurriculumItemType): IconName {
    switch (type) {
        case CurriculumItemType.VIDEO_LECTURE:
            return 'video';
        case CurriculumItemType.ARTICLE_LECTURE:
            return 'article';
        case CurriculumItemType.QUIZ:
            return 'lightbulb';
        case CurriculumItemType.CODING_EXERCISE:
            return 'code';
        case CurriculumItemType.PRACTICE_TEST:
            return 'quiz';
        case CurriculumItemType.ROLE_PLAY:
            return 'people';
        case CurriculumItemType.GRADED_ROLE_PLAY:
            return 'presentation';
        default:
            return 'article';
    }
}
